import { render } from "./ResetPasswordLanding.vue?vue&type=template&id=0db39eea&scoped=true"
import script from "./ResetPasswordLanding.vue?vue&type=script&lang=js"
export * from "./ResetPasswordLanding.vue?vue&type=script&lang=js"

import "./ResetPasswordLanding.vue?vue&type=style&index=0&id=0db39eea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db39eea"]])

export default __exports__